import React from 'react';
import styled from 'styled-components';
import { useLang } from '../context/LangContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

const PlayerContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9; /* 16:9 비율 유지 */
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const YouTubeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
`;

// YouTube URL에서 비디오 ID 추출하는 함수
const extractYouTubeVideoId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

const youtubePlayerTexts = {
  ko: {
    invalidUrl: '유효하지 않은 YouTube URL입니다.'
  },
  en: {
    invalidUrl: 'Invalid YouTube URL.'
  }
};

interface YouTubePlayerProps {
  youtubeUrl?: string;
  autoplay?: boolean;
  muted?: boolean;
}

const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ 
  youtubeUrl = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // 더미 YouTube URL
  autoplay = false,
  muted = true
}) => {
  const { lang } = useLang();
  const texts = youtubePlayerTexts[lang];
  const videoId = extractYouTubeVideoId(youtubeUrl);
  
  if (!videoId) {
    return (
      <Container>
        <PlayerContainer>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%', 
            color: 'white',
            fontSize: '16px'
          }}>
            {texts.invalidUrl}
          </div>
        </PlayerContainer>
      </Container>
    );
  }

  // YouTube embed URL 생성
  const embedUrl = `https://www.youtube.com/embed/${videoId}?${
    autoplay ? 'autoplay=1&' : ''
  }${
    muted ? 'mute=1&' : ''
  }rel=0&showinfo=0&controls=1`;

  return (
    <Container>
      <PlayerContainer>
        <YouTubeIframe
          src={embedUrl}
          title="YouTube Live Stream"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </PlayerContainer>
    </Container>
  );
};

export default YouTubePlayer;
